// No imports on purpose: the summary list, both forms, the overview popup and
// the summary hook all read this, and it must stay cheap to pull into tests.

/**
 * Notable Quotes (`curatedQuotes`) is hidden from the panel — product decision,
 * 19 Oct 2026; the app hides it too. Hidden, NOT deleted: the field is still
 * stored, still submitted and still translated, so setting this back to true
 * restores it everywhere with the data intact. Generate overview no longer
 * fills it (the backend stopped asking for quotes, 21 Oct 2026), so turning it
 * back on means restoring that too. It also stops being required while hidden,
 * since a required field with no input would block every save.
 */
export const SHOW_NOTABLE_QUOTES = false;
